import * as firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/auth';
import {EventType, t4} from "../components/DrawingDataType";
import * as PIXI from 'pixi.js';
import {WorkshopSceneState} from "./WorkshopSceneState";
import {SmileList} from "./SmileList";
import {GroupPath} from "./GroupPath";
import {SmileRegister} from "./SmileRegister";

export type WorkshopData = {
    videoId: string,
    scene: WorkshopSceneState
};

export const workshopDataDefault: WorkshopData = {
    videoId: '',
    scene: WorkshopSceneState.Wait
};

export class Store {
    static EVENT_UPDATED = 'updated';
    public static EVENT_REMOVED = 'rmoecd';

    static signal: PIXI.utils.EventEmitter = new PIXI.utils.EventEmitter();

    private static app: firebase.app.App;
    private static firestore: firebase.firestore.Firestore;
    private static database: firebase.database.Database;
    private static ref: firebase.database.Reference;

    private static _isWorkshop: boolean = false;

    static smileList: SmileList;

    static smileRegister: SmileRegister;

    private static groupPath: GroupPath;

    public static get isWorkshop() {
        return this._isWorkshop;
    }

    private static _groupId: string = 'dev';
    public static get groupId() {
        return this._groupId;
    }

    static _routerBasename: string;
    public static get routerBasename() {
        return this._routerBasename;
    }


    public static config: ConfigService;
    public static auth: AuthService;

    /*




    props




     */

    static get isDeviceMobile() {
        return this.device === 'mobile'
    }

    static get isDevicePc() {
        return this.device === 'pc';
    }

    private static _data: t4;
    static get data() {
        return this._data;
    }

    private static _device: string;
    public static get device() {
        return this._device;
    }

    static get guide() {
        return this._data.guide;
    }

    /*




    utils




     */

    static serverTimestamp() {
        return firebase.firestore.FieldValue.serverTimestamp();
    }

    /*




    common




     */

    static initialize(args: {
        device: string,
        firebase: any,
        groupId: string,
        isWorkshop: boolean,
        routerBasename: string
    }) {
        console.info('[ Store.initialize ] device=', args.device);
        console.info('[ Store.initialize ] groupId=', args.groupId);
        console.info('[ Store.initialize ] isWorkshop=', args.isWorkshop);
        console.info('[ Store.initialize ] routerBasename=', args.routerBasename);
        this._device = args.device;
        this._groupId = args.groupId;
        this._routerBasename = args.routerBasename;
        this._isWorkshop = args.isWorkshop;

        this._data = {
            paths: [],
            timestamp: Store.serverTimestamp(),
            country: '',
            prefecture: '',
            guide: (Math.random() * 8) >> 0,
            eventType: this.isWorkshop ? EventType.Workshop : EventType.FreeSpace,
            isDone: false
        };

        //
        const app = firebase.initializeApp(args.firebase);
        this.app = app;

        //
        const groupPath = new GroupPath(args.groupId);
        this.groupPath = groupPath;

        //
        this.firestore = app.firestore();

        //
        this.database_initialize(app);

        //
        this.smileList = new SmileList(this.firestore, groupPath);

        //
        const firestoreInstance = this.firestore;
        this.smileRegister = new SmileRegister(firestoreInstance, groupPath, this._data);

        //
        this.config = new ConfigService(this.firestore);

        //
        this.auth = new AuthService(app);
    }

    /*




    firestore / test




     */

    static async firestore_getCurrentGroups() {
        const db = this.firestore;
        const docRef = db.collection('config').doc('default');
        const documentSnapshot = await docRef.get();
        if (documentSnapshot.exists) {
            const data = documentSnapshot.data();
            if (!data) return '';
            return data.currentGroups;
            return '';
        }
        return '';
    }

    static async firestore_updateCurrentGroups(value:string){
        const db = this.firestore;
        const docRef = db.collection('config').doc('default');
        await docRef.set({currentGroups: value}, { merge: true });
    }

    static async firestore_group_isOpened(groupId:string) {
        const currentGroups = await Store.firestore_getCurrentGroups();
        if(!currentGroups) return false;

        for(let i of currentGroups.split('\n')){
            if(groupId===i) return true;
        }

        return false;
    }

    /*




    firestore / workshop




     */

    static firestore_ws_onChange(listener: (data: WorkshopData) => void) {
        this.firestore_ws_getDocumentReference(this._groupId).onSnapshot((doc) => {
            const data = doc.data();
            listener(
                data as WorkshopData
                || workshopDataDefault
            );
        });
    }

    private static firestore_ws_getDocumentReference(groupId: string) {
        const db = this.firestore;
        return db.collection('workshop').doc(groupId);
    }

    static async hoge(groupId: string) {
        const response = await this.firestore_ws_getDocumentReference(groupId).get();
        const data = response.data();
        return data as WorkshopData;
    }

    private static firestore_ws_update(groupId: string, data: any) {
        const db = this.firestore;
        try {
            data.updated = this.serverTimestamp();
            db.collection('workshop').doc(groupId).set(data, {merge: true});
        } catch (error) {
            console.error('Error writing new message to database', error);
        }
    }

    static firestore_ws_updateVideoId(groupId: string, videoId: string) {
        this.firestore_ws_update(groupId, {
            videoId: videoId
        });
    }

    static firestore_ws_updateScene(groupId: string, scene: WorkshopSceneState) {
        this.firestore_ws_update(groupId, {
            scene: scene
        });
    }

    static async firestore_ws_fetchGroupIds() {
        const db = this.firestore;
        const res = await db.collection('workshop')
            .limit(100)
            .orderBy('updated', 'desc')
            .get();
        const arr: string[] = [];
        res.forEach(result => {
            arr.push(result.id);
        });
        return arr;
    }

    /*




    realtime shared smile




     */

    private static database_initialize(app: firebase.app.App) {
        const db = app.database();
        this.database = db;

        this.ref = db.ref(this.groupPath.value).push();
    }

    private static database_onChanged(data: firebase.database.DataSnapshot) {

        // 自分のは出さない
        if (data.key === this.ref.key) return;

        // 自分の以外の更新をエミットする
        this.signal.emit(this.EVENT_UPDATED, data);
    }

    private static database_onRemoved(data: firebase.database.DataSnapshot) {
        this.signal.emit(this.EVENT_REMOVED, data);
    }

    static database_updatePaths() {
        const ref = this.ref;

        ref!.update({
            guide: this.data.guide,
            country: this.data.country,
            prefecture: this.data.prefecture,
            paths: this.data.paths
        });
    }

    static database_getRef(key: string) {
        return this.database.ref(this.groupPath.value + key);
    }

    static database_startListen() {
        const db = this.database;

        const realtimeSmilesRef = db.ref(this.groupPath.value);

        realtimeSmilesRef.on('child_changed', (data) => {
            this.database_onChanged(data);
        });

        realtimeSmilesRef.on('child_removed', (data) => {
            this.database_onRemoved(data);
        });
    }

    static database_endDraw() {
        const ref = this.ref;
        ref.remove();
    }

    static getFirestoreInstance() {
        return this.firestore;
    }
}

class AuthService {

    private _isLogin = false;

    constructor(private app: firebase.app.App) {
        // this.app.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        //     .then(()=>{
        //
        //     })
        //     .catch(reason => {
        //
        //     })

    }

    async aaa(email: string, password: string) {
        // var email = 'ikekou@gmail.com';
        // var password = 'ikekoupassword';

        try {
            await this.app.auth().signInWithEmailAndPassword(email, password);
            console.log('suc');
            this._isLogin = true;
            console.log('this.app.auth().currentUser', this.app.auth().currentUser);
            return true;
        } catch (error) {
            var errorCode = error.code;
            var errorMessage = error.message;

            // [START_EXCLUDE]
            if (errorCode === 'auth/wrong-password') {
                alert('Wrong password.');
            } else {
                alert(errorMessage);
            }
            console.log(error);
            return false;
        }
    }

    isLogin() {
        return this._isLogin;
    }

    onLogin(callback: () => void) {
        this.app.auth().onAuthStateChanged(user => {
            if (user) {
                callback();
            }
        })
    }
}

class ConfigService {
    constructor(
        private firestoreInstance: firebase.firestore.Firestore
    ) {
    }

    public async isRecruiting() {
        const docRef = this.firestoreInstance.collection('config').doc('default');
        const querySnapshot = await docRef.get();
        const message = querySnapshot.data();
        if (!message) return false;
        return message.isRecruiting;
    }

    updateRecruiting(isRecruiting: boolean) {
        console.log('isRecruiting', isRecruiting);
        console.log('[ ConfigService.updateRecruiting : 318 ]');
        const docRef = this.firestoreInstance.collection('config').doc('default');
        console.log('[ ConfigService.updateRecruiting : 320 ]');
        docRef.set({isRecruiting: isRecruiting}, { merge: true });
        console.log('[ ConfigService.updateRecruiting : 322 ]');
    }
}